import {vrmVueModule} from '@/angular-bridge/module';
import camelCase from 'camel-case';

// Create a dynamic include, which imports all .vue files (recursivly) under the supplied path
const context = require.context('@/vue/components/pages/', true, /\.vue$/);

context.keys()
    // Imports/executes each module with the dynamic context
    .map(context)
    // For each executed module, grab the default export of that module
    .map(exports => exports.default)
    // Only keep the exported components that are marked by the angular directive
    .filter(component => component.angularRoute)
    // Generate an angular directive for all remaining components
    .forEach(generateRouteBinding);

function generateRouteBinding(component) {
    const {name, url, slot, data} = component.angularRoute;

    const scopedName = 'vrm.vue.page.' + name;
    const directiveName = camelCase(scopedName);

    vrmVueModule.value(directiveName, component);

    vrmVueModule.config(/* @ngInject */ function ($stateProvider) {
        $stateProvider.state(name, {
            url,
            views: {
                [slot]: {
                    originalVueComponent: component,
                    template: `<vue-component name="${directiveName}"></vue-component>`,
                },
            },
            data,
        });
    });
}
